// カーソル追従の点は、PC の細かいポインタだけで動かす。移動距離で色と大きさを決め、位置はばねで追従し、止まったら描画を休む。
// 2026/10/6 松見さん＝溶け替わり（ガイドラインの色 #f39324→#ecb375→#74a9dc→#008cff を OKLab で補間）・追従は距離 50px（速さに関係なく同じ振れ・表示は両端まで引き伸ばす・止めると止まる）・最大 28px（AMP 1.0）。灰色は k≈.58 で約 10px/片道（補色のため避けられない）。
(function () {
  'use strict';

  if (document.documentElement.hasAttribute('data-dt-stalker')) return;
  document.documentElement.setAttribute('data-dt-stalker', '1');

  var BASE = 14;
  var NATIVE = 35;
  var AMP = 1.0;
  var SIZE_P = 252;
  var COLOR_P = 600;
  var LINK = 35;
  var LINK_SEL = 'a[href], button:not([disabled]), summary, [role="button"], input[type="submit"]:not([disabled]), label[for], select, .slide-arrow';
  var K = 0.22;
  var DAMP = 0.62;
  var SIZE_SMOOTH = 0.14;
  // 色の追従は時間でなく距離。速さに関係なく同じ振れ（600px 周期で約 0.89）・止めた瞬間に止まる。2026/10/6 松見さん 案 A（Opus レビュー P1 の直し）
  var COLOR_LAG = 50;
  // 表示では振れを 1/COLOR_GAIN 倍に戻し、両端の純色まで届かせる（Opus レビュー R2 P2-1）。600px 周期の cos 波に距離 50px の一次遅れをかけた時の振れの倍率。
  var COLOR_GAIN = 1 / Math.sqrt(1 + Math.pow(2 * Math.PI * COLOR_LAG / COLOR_P, 2));
  var STEP = 16.667;

  var el = document.getElementById('stalker');
  if (!el || typeof matchMedia !== 'function') return;

  var finePointer = matchMedia('(hover: hover) and (pointer: fine)');
  if (!finePointer.matches) return;

  var reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
  var palette;
  var tx = 0;
  var ty = 0;
  var x = 0;
  var y = 0;
  var px = 0;
  var py = 0;
  var vx = 0;
  var vy = 0;
  var dist = 0;
  var lastDist = 0;
  var lastMouse = null;
  var hasMouse = false;
  var onLink = false;
  var sz = BASE;
  var cval = 0;
  var raf = 0;
  var scrollRaf = 0;
  var lastTime = 0;
  var springRemainder = 0;

  function lin(c) {
    c /= 255;
    return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
  }

  function gam(c) {
    c = c <= 0.0031308 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055;
    return Math.max(0, Math.min(255, Math.round(c * 255)));
  }

  function toLab(rgb) {
    var r = lin(rgb[0]);
    var g = lin(rgb[1]);
    var b = lin(rgb[2]);
    var l = Math.cbrt(0.4122214708 * r + 0.5363325363 * g + 0.0514459929 * b);
    var m = Math.cbrt(0.2119034982 * r + 0.6806995451 * g + 0.1073969566 * b);
    var s = Math.cbrt(0.0883024619 * r + 0.2817188376 * g + 0.6299787005 * b);
    return [
      0.2104542553 * l + 0.7936177850 * m - 0.0040720468 * s,
      1.9779984951 * l - 2.4285922050 * m + 0.4505937099 * s,
      0.0259040371 * l + 0.7827717662 * m - 0.8086757660 * s
    ];
  }

  function fromLab(L) {
    var l = Math.pow(L[0] + 0.3963377774 * L[1] + 0.2158037573 * L[2], 3);
    var m = Math.pow(L[0] - 0.1055613458 * L[1] - 0.0638541728 * L[2], 3);
    var s = Math.pow(L[0] - 0.0894841775 * L[1] - 1.2914855480 * L[2], 3);
    return [
      gam(4.0767416621 * l - 3.3077115913 * m + 0.2309699292 * s),
      gam(-1.2684380046 * l + 2.6097574011 * m - 0.3413193965 * s),
      gam(-0.0041960863 * l - 0.7034186147 * m + 1.7076147010 * s)
    ];
  }

  var LO = toLab([243, 147, 36]);
  var LB = toLab([0, 140, 255]);
  var STP = [
    [0, LO],
    [0.42, toLab([236, 179, 117])],
    [0.72, toLab([116, 169, 220])],
    [1, LB]
  ];

  palette = buildPalette();

  function labMix(k) {
    for (var i = 1; i < STP.length; i++) {
      if (k <= STP[i][0]) {
        var a = STP[i - 1];
        var b = STP[i];
        var t = (k - a[0]) / (b[0] - a[0]);
        return fromLab([
          a[1][0] + (b[1][0] - a[1][0]) * t,
          a[1][1] + (b[1][1] - a[1][1]) * t,
          a[1][2] + (b[1][2] - a[1][2]) * t
        ]);
      }
    }
    return fromLab(LB);
  }

  function buildPalette() {
    var colors = [];
    for (var i = 0; i <= 100; i++) {
      colors.push(labMix(i / 100));
    }
    return colors;
  }

  function clamp(v, min, max) {
    return Math.max(min, Math.min(max, v));
  }

  function wave(P) {
    return (1 - Math.cos(2 * Math.PI * dist / P)) / 2;
  }

  function smoothing(coef, dt) {
    return 1 - Math.pow(1 - coef, dt / STEP);
  }

  function isElement(node) {
    return node && node.nodeType === 1;
  }

  function linkFromEventTarget(target) {
    if (!isElement(target) || typeof target.closest !== 'function') return false;
    return !!target.closest(LINK_SEL);
  }

  function refreshEl() {
    if (el && el.isConnected) return true;
    el = document.getElementById('stalker');
    return !!el;
  }

  function ensureFrame() {
    if (!raf) {
      lastTime = 0;
      raf = requestAnimationFrame(frame);
    }
  }

  function render(rx, ry) {
    if (!refreshEl()) return false;

    var color = palette[Math.round(clamp((cval - 0.5) / COLOR_GAIN + 0.5, 0, 1) * 100)];
    var alpha = 1 - clamp((sz / BASE - 1) / 2.5, 0, 1) * 0.5;

    el.style.transform = 'translate3d(' + rx.toFixed(2) + 'px,' + ry.toFixed(2) + 'px,0) scale(' + (sz / NATIVE).toFixed(3) + ')';
    el.style.background = 'rgba(' + color[0] + ',' + color[1] + ',' + color[2] + ',' + alpha.toFixed(2) + ')';
    return true;
  }

  function onMouseMove(e) {
    tx = e.clientX;
    ty = e.clientY;
    onLink = linkFromEventTarget(e.target);

    if (!hasMouse) {
      x = tx;
      y = ty;
      px = x;
      py = y;
      vx = 0;
      vy = 0;
      lastMouse = { x: tx, y: ty };
      lastDist = dist;
      hasMouse = true;
      if (!render(x, y)) return;
    } else if (lastMouse) {
      dist += Math.hypot(tx - lastMouse.x, ty - lastMouse.y);
      lastMouse.x = tx;
      lastMouse.y = ty;
    }

    if (!refreshEl()) return;
    el.style.opacity = '1';
    ensureFrame();
  }

  function onMouseLeave() {
    hasMouse = false;
    lastMouse = null;
    onLink = false;
    if (!refreshEl()) return;
    el.style.opacity = '0';
  }

  function onMouseOver(e) {
    if (isElement(e.target) && e.target.tagName === 'IFRAME') {
      onMouseLeave();
    }
  }

  function onMouseOut(e) {
    if (e.relatedTarget === null) {
      onMouseLeave();
    }
  }

  function onScroll() {
    if (!hasMouse || scrollRaf) return;
    scrollRaf = requestAnimationFrame(function () {
      scrollRaf = 0;
      if (!hasMouse) return;
      onLink = linkFromEventTarget(document.elementFromPoint(tx, ty));
      ensureFrame();
    });
  }

  function advanceSpring(dt) {
    if (reduceMotion.matches) {
      x = tx;
      y = ty;
      px = x;
      py = y;
      vx = 0;
      vy = 0;
      springRemainder = 0;
      return;
    }

    springRemainder += dt;
    var steps = 0;
    while (springRemainder >= STEP && steps < 4) {
      px = x;
      py = y;
      vx = vx * DAMP + (tx - x) * K;
      vy = vy * DAMP + (ty - y) * K;
      x += vx;
      y += vy;
      springRemainder -= STEP;
      steps++;
    }
    if (steps === 4) {
      springRemainder = 0;
    }
  }

  function isSettled(targetSize) {
    return Math.hypot(tx - x, ty - y) < 0.05 &&
      Math.hypot(vx, vy) < 0.02 &&
      Math.abs(targetSize - sz) < 0.05;
  }

  function frame(now) {
    raf = 0;
    var dt = lastTime ? Math.min(now - lastTime, 64) : STEP;
    lastTime = now;

    var targetSize = onLink ? LINK : BASE * (1 + (reduceMotion.matches ? 0 : AMP * wave(SIZE_P)));
    var targetColor = wave(COLOR_P);
    var sizeF = smoothing(SIZE_SMOOTH, dt);
    var colorF = 1 - Math.exp(-(dist - lastDist) / COLOR_LAG);
    var rx;
    var ry;
    var settled;

    advanceSpring(dt);
    sz += (targetSize - sz) * sizeF;
    cval += (targetColor - cval) * colorF;
    lastDist = dist;
    settled = isSettled(targetSize);
    if (reduceMotion.matches || settled) {
      rx = x;
      ry = y;
    } else {
      rx = px + (x - px) * (springRemainder / STEP);
      ry = py + (y - py) * (springRemainder / STEP);
    }

    if (!render(rx, ry)) return;
    if (hasMouse && refreshEl()) {
      el.style.opacity = '1';
    }

    if (!settled) {
      raf = requestAnimationFrame(frame);
    } else {
      lastTime = 0;
      springRemainder = 0;
    }
  }

  document.addEventListener('mousemove', onMouseMove, { passive: true });
  document.addEventListener('mouseover', onMouseOver, { passive: true });
  document.addEventListener('mouseout', onMouseOut, { passive: true });
  document.documentElement.addEventListener('mouseleave', onMouseLeave, { passive: true });
  addEventListener('scroll', onScroll, { passive: true });
  addEventListener('blur', onMouseLeave, { passive: true });
})();
